export const l = {
    "dty": "Nuvem do Elevador",
    "subtitle": "Plataforma integrada de gestão de segurança de elevadores",
    "smart_screen": "Tela inteligente",
    "face": "Reconhecimento facial",
    "id": "ID",
    "save": "Salvar",
    "save_success": "Salvo com sucesso",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "create": "Criar novo",
    "fresh": "Atualizar",
    "add": "Adicionar",
    "add_success": "Adicionado com sucesso",
    "add_fail": "Falha ao adicionar",
    "edit": "Editar",
    "edit_success": "Editado com sucesso",
    "edit_fail": "Falha ao editar",
    "delete": "Excluir",
    "delete_success": "Excluído com sucesso",
    "delete_fail": "Falha ao excluir",
    "no_data": "Não preenchido",
    "no_specific_location": "Localização não selecionada",
    "total_data": "Total",
    "date": "Data",
    "unit1": "item(s)",
    "unit2": "yuan",
    "data": "Dados",
    "warn": "Aviso",
    "continue": "Continuar",
    "success": "Sucesso",
    "fail": "Falha",
    "open": "Abrir",
    "close": "Fechar",
    "check": "Visualizar",
    "prompt": "Prompt",
    "yes": "Sim",
    "no": "Não",
    "close_f_notice": "Fechar aviso de falha",
    "file": "Arquivo",
    "remark": "Por favor, insira o nome de usuário",
    "remark1": "Por favor, insira o número de telefone ou nome de usuário",
    "remark2": "Por favor, insira a senha",
    "remark3": "Por favor, insira o número de telefone",
    "remark03": "Por favor, insira o e-mail",
    "remark4": "Por favor, insira o código de verificação",
    "remark5": "Por favor, insira a nova senha",
    "remark6": "Por favor, insira novamente a nova senha",
    "remark7": "Por favor, insira a senha antiga",
    "remark8": "A senha antiga não pode estar vazia",
    "remark9": "A nova senha não pode estar vazia",
    "remark10": "Por favor, insira palavras-chave da empresa ou departamento",
    "remark11": "Por favor, insira um número de telefone válido",
    "remark12": "Este número de telefone já está registrado",
    "remark13": "Este nome de usuário já está registrado",
    "remark14": "Por favor, insira um e-mail válido",
    "remark15": "Valor do recarregamento (yuan)",
    "remark16": "Por favor, insira o valor do recarregamento",
    "remark17": "Conta do fabricante",
    "remark18": "Clique no botão 'Confirmar' para concluir o recarregamento",
    "remark19": "Por favor, insira o nome do condomínio",
    "remark20": "Endereço detalhado não preenchido",
    "remark21": "Endereço detalhado, por exemplo: Rua Shiji, 37...",
    "remark22": "Limite diário QR code",
    "remark23": "Número padrão de atualizações diárias do QR code, pode ser modificado ao conceder permissão de acesso ao elevador",
    "remark24": "Por favor, preencher completamente",
    "remark25": "Existe um arquivo com o mesmo nome. Deseja continuar o upload e substituir?",
    "remark26": "Falha no upload do arquivo. Apenas arquivos APK são suportados",
    "remark27": "Por favor, selecione a cidade",
    "remark28": "Nota: Após o upload bem-sucedido do APK, o tamanho e o número da versão são sincronizados automaticamente com o banco de dados. Antes do upload, modifique o nome do arquivo para 'diantiyun.apk'.",
    "remark29": "Não foi possível carregar",
    "remark30": "Nota: O tamanho, nome e caminho do arquivo APK enviado aqui não precisam ser preenchidos, mas o número da versão da skin deve ser configurado manualmente",
    "remark31": "Por favor, preencha os parâmetros de push",
    "remark32": "Por favor, preencha a descrição textual dos parâmetros",
    "remark33": "Este item não pode estar vazio",
    "remark34": "Por favor, preencha a chave do campo",
    "remark35": "Por favor, preencha a descrição textual do campo",
    "remark36": "Este número de telefone já está registrado",
    "remark37": "Este nome de usuário já está registrado",
    "remark38": "Por favor, preencha o nome de usuário",
    "remark39": "Por favor, preencha o nome",
    "remark39_a": "Por favor, preencha a senha",
    "remark39_b": "Por favor, insira novamente a senha",
    "remark39_c": "Por favor, insira a nova senha",
    "remark39_d": "A senha não pode conter espaços",
    "remark40": "Por favor, preencha o número de matrícula",
    "remark14_c": "As duas senhas inseridas não coincidem",
    "remark41": "Por favor, preencha o número de telefone",
    "remark42": "Por favor, insira o nome ou telefone do proprietário",
    "remark43": "Identidade atual do administrador do condomínio",
    "remark44": "Por favor, selecione o número do edifício e o número do bloco",
    "remark45": "Andar não selecionado",
    "remark46": "Data de expiração não selecionada",
    "remark47": "Número do edifício e bloco não selecionados",
    "remark48": "Data limite da permissão de acesso ao elevador",
    "remark49": "Número máximo de aquisições não preenchido",
    "remark50": "Número máximo de aquisições por dia",
    "remark51": "Número máximo de aquisições de QR code para acesso ao elevador por dia",
    "remark52": "Adicionar chave de QR code para acesso ao elevador",
    "remark53": "Tem certeza de que deseja mudar a identidade para gerência imobiliária?",
    "remark54": "Tem certeza de que deseja mudar a identidade para proprietário comum?",
    "remark55": "Tem certeza de que deseja excluir as informações de localização atual do proprietário?",
    "remark56": "Por favor, selecione o local",
    "remark57": "O proprietário já existe. As novas informações de registro do proprietário serão vinculadas a este número de telefone. Deseja continuar?",
    "remark58": "Por favor, selecione o condomínio operacional",
    "remark59": "Nenhum elevador principal encontrado neste local",
    "remark60": "Falha ao obter informações sobre os andares do elevador",
    "remark61": "Sem permissão de acesso ao elevador, por favor, preencha o endereço de correspondência",
    "remark62": "Tem certeza de que deseja excluir a permissão de acesso ao elevador no local atual?",
    "remark63": "Tem certeza de que deseja excluir este proprietário? Após a exclusão, todas as permissões de acesso ao elevador e informações de endereço de correspondência do proprietário atual no condomínio serão excluídas",
    "remark64": "Por favor, selecione o condomínio atual operacional",
    "remark65": "Dados faciais não registrados",
    "remark66": "Dados faciais já registrados",
    "remark67": "Por favor, insira palavras-chave",
    "remark68": "Apenas formatos csv, xlsx e xls são suportados. Por favor, confirme e faça o upload",
    "remark69": "Excel",
    "remark70": "Por favor, insira palavras-chave",
    "remark71": "Por favor, selecione o bairro pertencente (pesquisa disponível)",
    "remark72": "Por favor, selecione o fabricante (pode pesquisar)",
    "remark73": "Por favor, preencha",
    "remark74": "Por favor, selecione o local de instalação",
    "remark75": "Endereço detalhado, composto por província, cidade, distrito e endereço específico",
    "remark76": "Nota: Esta opção é usada para integrar com a plataforma do departamento de supervisão local. Por favor, preencha se necessário",
    "remark77": "Por favor, selecione a cidade onde o elevador está localizado (pode pesquisar)",
    "remark78": "Por favor, selecione o tipo de elevador",
    "remark79": "Se este elevador deve ser selecionado como o elevador principal",
    "remark80": "Por favor, determine o local do elevador principal",
    "remark81": "Por favor, determine o elevador principal",
    "remark82": "Por favor, selecione as filiais da empresa visíveis pelo elevador (pode pesquisar)",
    "remark83": "Por favor, selecione a empresa de manutenção (pode pesquisar)",
    "remark84": "Por favor, selecione o responsável pela manutenção (pode pesquisar, pode selecionar vários)",
    "remark85": "Por favor, selecione o responsável pelo elevador (pode pesquisar, pode selecionar vários)",
    "remark86": "Por favor, selecione a empresa de publicidade (pode pesquisar)",
    "remark87": "Por favor, selecione os responsáveis por alertas de falhas (pode pesquisar, pode selecionar vários)",
    "remark88": "Por favor, insira a localização aproximada",
    "remark89": "Por favor, insira um número entre 1 e 64",
    "remark90": "Por favor, insira informações completas",
    "remark91": "Por favor, insira um número de telefone válido",
    "remark92": "Por favor, selecione os elevadores para processamento em lote",
    "remark93": "Clique em 'Confirmar' para sair da página atual e ir para a página de gerenciamento de condomínios",
    "remark94": "O elevador atual já está na lista de loteamento, não faça operações consecutivas",
    "remark95": "Nenhum elevador favoritado adicionado",
    "remark96": "Nenhuma informação de campo de interface configurada para a cidade atual ou empresa atual. Por favor, contate o administrador",
    "remark97": "Por favor, primeiro selecione o condomínio所属 do elevador",
    "remark98": "Nenhum arquivo selecionado",
    "remark99": "Para garantir a uniformidade da estrutura de dados, por favor, preencha estritamente de acordo com o modelo!",
    "remark100": "Modelo de preenchimento de informações de registro de elevadores na plataforma Nuvem do Elevador",
    "remark101": "Por favor, insira o conteúdo da pesquisa",
    "remark102": "Por favor, preencha o ID do terminal WCR",
    "remark103": "Por favor, selecione o departamento",
    "remark104": "Por favor, insira o nome do elevador, nome da falha, etc.",
    "remark105": "Por favor, selecione o mês específico",
    "remark106": "Seu pedido de recarregamento foi criado com sucesso. O sistema está processando.",
    "login_account": "Faça login na sua conta",
    "mobile_username": "Número de telefone ou nome de usuário",
    "mobile": "Telefone",
    "pwd": "Senha",
    "pwd_old": "Senha antiga",
    "pwd_new": "Nova senha",
    "confirm_new_pwd": "Confirme a nova senha",
    "login": "Login",
    "forget_pwd": "Esqueci a senha",
    "captcha": "Código de verificação",
    "get_captcha": "Obter código de verificação",
    "submit": "Enviar",
    "back_official_web": "Voltar para o site oficial",
    "back_login": "Voltar para o login",
    "goback": "Voltar",
    "monitor": "Monitoramento",
    "err_403": "403 - Sem permissão",
    "err_404": "404 - Página não encontrada",
    "err_net": "Não é possível acessar este site",
    "err_500": "Erro 500 no servidor",
    "home": "Página inicial",
    "sim_statistics": "SIM",
    "normalCount": "Normal",
    "oweCount": "Em débito",
    "stopCount": "Desativado",
    "ExpireCount": "Expirado",
    "all_lift": "Todos os elevadores",
    "cum_fault": "Falhas acumuladas",
    "online_lift": "Elevadores online",
    "maintenance_lift": "Elevadores em manutenção",
    "fault_num": "Número de falhas",
    "today_fault": "Falhas de hoje",
    "today_running": "Operação de hoje",
    "today_add_lift": "Elevadores adicionados hoje",
    "online": "Online",
    "offline": "Offline",
    "online_rate": "Taxa de elevadores online",
    "wait_maintained": "Aguardando manutenção",
    "maintained": "Manutenção concluída",
    "device_maintenance": "Manutenção de elevadores",
    "fault_rate": "Taxa de falhas de elevadores",
    "normal": "Normal",
    "repair": "Manutenção",
    "finish": "Concluído",
    "terminal_statistics": "Estatísticas de terminais",
    "terminal_app": "Aplicativo móvel Nuvem do Elevador",
    "terminal_smart": "Terminal de tela inteligente",
    "terminal_face": "Terminal de reconhecimento facial",
    "terminal_new_wcr": "Terminal WCR versão 4G",
    "terminal_old_wcr": "Terminal WCR versão 2G",
    terminal_wcr: "WCR",
    "maintenance_statistics": "Dados de manutenção",
    "fault_deal_statistics": "Dados de falha",
    "person_info": "Informações pessoais",
    "job_num": "Número de matrícula",
    "position": "Cargo",
    "phone_no": "Telefone",
    "e_mail": "E-mail",
    "company": "Empresa",
    "department": "Departamento",
    "select": "Selecionar",
    "change_pwd": "Alterar senha",
    "log_out": "Sair",
    "wipe_cache": "Limpar cache",
    "system_manage": "Sistema",
    "user_manage": "Gerenciamento de usuários",
    "company_structure": "Organização",
    "role_manage": "Papel",
    "add_role": "Adicionar nova função",
    "username": "Nome de usuário",
    "username_account": "Usuários",
    "name": "Nome",
    "real_name": "Nome real",
    "birthday": "Data de nascimento",
    "operation": "Operação",
    "pay_account": "Pagamento",
    "pay_manage": "Pagamento",
    "recharge": "Recarregar",
    "recharge_amount": "Recargar Quantidade",
    "send_sms": "Enviar notificação por SMS",
    "recharge_success": "Recarregamento bem-sucedido",
    "community": "Condomínio",
    unfold: "Expandir",
    community_name: "Nome do condomínio",
    region: "Região",
    region_of: "Região",
    detail_address: "Endereço detalhado",
    address: "Endereço",
    community_info: "Informações do condomínio",
    create_community: "Criar condomínio",
    list_page: 'Página de lista',
    detail_page: 'Página de detalhes',
    report_interval: 'Intervalo de relatório',
    duration: 'Duração (segundos)',
    para_monitor: 'Monitoramento de parâmetros',
    system_setting: 'Configurações do sistema',
    system_select: 'Opções de configuração do sistema',
    basic_set: 'Configurações básicas',
    personal_account: 'Conta pessoal',
    info_set: 'Configuração de informações',
    data_monitor_page: 'Página de monitoramento de dados',
    data_monitor_set: 'Monitoramento de dados',
    webRTC_set: 'Configuração do webRTC',
    webRTC_related_set: 'Configurações relacionadas ao webRTC',
    app_v_manage: 'Gerenciamento de versões do App',
    dtyApp_v_manage: 'App Versão',
    face_v_manage: 'Reconhecimento facial',
    faceApp_v_manage: 'Reconhecimento App Versão',
    smart_v_manage: 'Inteligente',
    smartApp_v_manage: 'Inteligente App',
    smartlite_v_manage: 'Inteligente App Lite',
    smartlitApp_v_manage: 'Inteligente App Lite Versão',
    fault_set: 'Configuração de falhas',
    fault_msg_set: 'Lembrete de falha',
    aliyun_interface_set: 'Configuração de interface da Aliyun',
    newWcr_v_manage: 'Gerenciamento de versões do novo Wcr',
    api_set1: 'Configurações de empurramento',
    api_set2: 'Configurar campos de permissão de acesso',
    sys_nettrans_server: "Difusão intranet",
    current_department: 'Departamento atual',
    upload_avatar: 'Carregar avatar',
    upload_success: 'Carregado com sucesso',
    upload_fail: 'Falha no upload',
    upload_apk: 'Clique para carregar arquivo apk',
    upload_img: 'Carregar imagem',
    upload: 'Carregar',
    all_fault_alarm: 'Selecionar todos os alertas de falhas',
    all_sms_alarm: 'Selecionar todos os envios de SMS',
    package: 'Pacote',
    package_name: 'Nome do pacote',
    package_type: 'Tipo de pacote',
    month_sub: 'Mensal',
    superposition: 'Sobreposição',
    flow_data: 'Tráfego',
    original_price: 'Preço original',
    discount_price: 'Preço com desconto',
    package_id: 'Número do pacote',
    list_v: 'Lista de versões',
    set_list: 'Lista de configurações',
    region_select: 'Rótulo da plataforma de push',
    region_no_select: '',
    push_type: 'Método de push',
    push_setting: 'Configuração de push',
    push_name: 'Nome da plataforma',
    push_port:'Porta de push',
    pingtai: 'Plataforma',
    push_time: 'Hora de push',
    manufacturer: 'Empresa visível',
    select_manufacturer1: 'Por favor, selecione a empresa visível pelo elevador',
    select_manufacturer2: 'Por favor, selecione a empresa visível pelo elevador (pode pesquisar)',
    push_para: 'Parâmetros de push',
    para_des: 'Descrição dos parâmetros',
    add_filed: 'Adicionar campo',
    file_des: 'Descrição textual do campo',
    add_push: 'Adicionar configuração de push',
    fault_name: 'Nome da falha',
    fault_mean: 'Significado da falha',
    fault_alarm: 'Alerta de falha',
    send_sms2: 'Enviar SMS',
    take_ladder_manage: 'Escadas',
    owner_manage: 'Gerenciamento de proprietários',
    add_owner: 'Adicionar proprietário',
    build_unit: 'Unidade do edifício',
    lift_permission: 'Permissão elevador',
    lift_position: 'Posição',
    select_floor: 'Selecionar andar',
    deadline: 'Data de expiração',
    face_lift: 'Permissão facial',
    face_collected: 'Rosto já coletado',
    face_no_collect: 'Rosto não coletado',
    property_manage: 'Gerenciamento imobiliário',
    ordinary_owner: 'Proprietário comum',
    lift_no_permission: 'Sem permissão de acesso ao elevador',
    entry_time: 'Hora de registro',
    authorize: 'Autorizar',
    authorize_success: 'Autorizado com sucesso',
    authorize_fail: 'Falha na autorização',
    give_lift: 'Autorizar permissão de acesso ao elevador',
    owner_lift: 'Permissão de acesso ao elevador do proprietário',
    add_address: 'Adicionar endereço',
    add_new_address: 'Adicionar novo endereço',
    community_list: 'Lista de condomínios',
    //已删钥匙
    deleted_key: 'Chave excluída',
    deleted_keys: 'Lista de chaves excluídas',
    bound_lift: 'Elevador vinculado',
    key_floor: 'Andar onde está localizado',
    key_owner: 'Nome do proprietário da chave',
    // 导航 电梯管理
    device_manage: 'Equipamento',
    //设备列表
    device_list: 'Lista de elevadores',
    remove_device_list: "Lista de elevadores excluídos",
    my_focus: 'Meus favoritos',
    device_monitor: 'Monitoramento de elevadores',
    map_location: 'Localização no mapa',
    back_devices: 'Voltar para a lista de elevadores',
    batch_import: 'Importação em lote',
    filter: 'Filtrar',
    filter_lift: 'Filtrar elevadores',
    elevator_name: 'Nome do elevador',
    device_model: 'Modelo',
    device_type: 'Tipo de elevador',
    device_number: 'Código',
    device_num: 'Número do dispositivo',
    terminal_id: 'ID do terminal',
    batch_operation: 'Operação em lote',
    add_device: 'Adicionar elevador',
    batch_edit: 'Edição em lote',
    location: 'Localização geográfica',
    set_excel: 'Opções de configuração da planilha Excel',
    down_excel: 'Download do modelo de planilha',
    select_bound_lift: 'Selecionar elevador real para vincular',
    virtual_lift_id: 'ID do terminal WCR do elevador virtual',
    wcr2G_terminal: 'WCR 2G',
    total_floor: 'Total de andares',
    floor: 'Andar',
    positive_floor: 'Andares positivos',
    negative_floor: 'Andares negativos',
    floor_editor: 'Editor de andares',
    through_door: 'Porta transversal',
    manual_door: 'Porta manual',
    remote_sync: 'Sincronização remota',
    select_push_city: 'Plataforma de push',
    lift_type: 'Tipo de elevador',
    lift_id: 'Número do elevador',
    lift_mode: 'Modelo do elevador',
    rated_speed: 'Velocidade',
    rated_load: 'Carga',
    main_lift: 'Elevador principal selecionado',
    lift: 'Elevador',
    virtual_lift: 'Elevador virtual',
    get_coordinates: 'Obter latitude e longitude',
    company_logo: "Carregar logotipo da empresa",
    latitude: 'Latitude',
    longitude: 'Longitude',
    select_location: 'Clique para selecionar a localização',
    face_terminal_id: 'ID do terminal de reconhecimento facial',
    manufacturer_branch: 'Filial da empresa visível pelo elevador',
    mt_company: 'Empresa de manutenção',
    mt_person: 'Manutenção',
    add_maintenance: 'Criar novo responsável pela manutenção',
    principal: 'Responsável',
    add_principal: 'Criar novo responsável',
    terminal: 'Terminal',
    ad_company: 'Anúncios',
    alarm_mobile: 'Telemóvel de alerta',
    alarm_description: 'Alerta por SMS',
    add_alarm_mobile: 'Criar novo responsável por alertas',
    sms_count: 'Número de SMS enviados', // 阿里云
    sms_limit: 'Limite de SMS',   // 阿里云
    sms_enable: 'Funcionalidade de SMS',  // 阿里云
    sms_enable_0: 'Desativado',
    sms_enable_1: 'Apenas nacional',
    sms_enable_2: 'Nacional e internacional',
    add_capacity: 'Capacidade adicional',
    select_all: 'Selecionar todos',
    unbound: 'Não vinculado',
    batch_edit_info: 'Editar informações de elevadores em lote',
    select_position: 'Calibração de posição',
    current_longitude: 'Longitude da posição atual',
    current_latitude: 'Latitude da posição atual',
    selected_lifts: 'Lista de elevadores selecionados',
    clear: 'Limpar',
    lift_info: 'Informações do elevador',
    device_state: 'Estado do elevador',
    terminal_type: 'Tipo de terminal',
    lift_name: 'Nome do elevador',
    device_unique_id: 'Número de identificação único do elevador',
    lift_factory: 'Fábrica de elevadores',
    dty_model: 'Modelo de teste da Nuvem do Elevador',
    code_model: '(Definido pelo fabricante)',
    lift_type1: 'Elevadores de tração e acionamento forçado',
    lift_type2: 'Elevadores para objetos',
    lift_type3: 'Elevadores hidráulicos',
    lift_type4: 'Escadas rolantes e passarelas móveis',
    video_monitor: 'Monitoramento vídeo',
    scan_lift: 'Acesso ao elevador via código QR',
    video_call: 'Intercomunicação remota',
    click_help: 'Botão de emergência',
    video_ad: 'Publicidade em vídeo',
    //********************************************************************************
    terminal_operation_list: 'Lista de operações do terminal',
    fault_statistics: 'Falhas de elevadores',
    sendSync: 'Sincronizar andares',
    get_real_time_param: 'Real parâmetros ',
    real_time_param: 'Parâmetros em tempo real',
    restart_APP: "Reiniciar o App do terminal",
    read_param: 'Terminal parâmetros',
    read_setting_file: "Ler arquivo de configuração",
    smart_screen_param: 'Parâmetros da tela inteligente',
    sim_query: 'Consulta de cartão SIM',
    check_face_version: 'Versão do Facial',
    check_screen_version: 'Versão do Android',
    down_ladder_code: 'Download Escadeiras',
    pusher_log: 'Log de push',
    log: 'Log',
    Real_time_status: 'Status em tempo real',
    history_monitor: 'Monitor Histórico',
    remote_file: 'Gerenciamento de arquivos remotos',
    driver: 'Motorista',
    special: 'Especial',
    fire: 'Incêndio',
    fire_start: 'Estado inicial de incêndio',
    Lock_ladder: 'Travar elevador',
    password: 'Senha',
    confirm_password: 'Confirmar senha',
    fault: 'Falha',
    scram_loop: 'Pare!',
    door_lock_loop: 'Fechado ',
    overload: 'Sobrecarga',
    CAN_fault: 'Falha CAN',
    blackout_emergency: 'Emergência de falta de energia',
    earthquake: 'Terremoto',
    basic_function: 'Funcionalidade básica',
    data_monitor: 'Monitoramento de dados',
    not_configed: 'Não',
    extend_functionality: 'Funcionalidade estendida',
    remote_operate: 'Operação remota',
    remote_lock_ladder: 'Travar ',
    remote_unParking:'Desbloquear remotamente',
    remote_unlock_ladder: 'Desbloquear elevador remotamente',
    remote_stop: 'Parar',
    remove_stop: 'Desativar parada',
    remote_down: 'Forçada',
    remote_update_pwd: 'Atualizar período de senha remotamente',
    password_cycle: 'Período',
    remote_reset: 'Resetar',
    device_param: 'Parâmetros do elevador',
    main_board_param: 'Parâmetros',
    extension_data: 'Estendidos',
    outbound_situation: 'Situação de chamadas externas',
    in_select_case: 'Situação de seleções internas',
    in_select: 'Seleção interna',
    out_select: 'Chamada externa',
    up_select: 'Chamada para cima',
    down_select: 'Chamada para baixo',
    alert_warn: 'O elevador não está vinculado a um terminal ou o terminal está offline',
    simulation: 'Simulação',
    video: 'Vídeo',
    stream_m3u8: 'Fluxo de vídeo m3u8',
    item_name: 'Nome do projeto',
    device_address: 'Posição do elevador',
    no_terminal_id: 'Terminal não vinculado',
    current_fault_record: 'Registro de falhas atuais do elevador',
    return_table: 'Voltar para a tabela',
    change_chart: 'Mudar para gráfico estatístico',
    note: 'Observação',
    loading1: 'Carregando parâmetros de operação do elevador remotamente...',
    loading2: 'Conectando ao terminal...',
    terminal_param: 'Parâmetros do terminal',
    param_list: 'Lista de parâmetros',
    return_param_content: 'Conteúdo de retorno dos parâmetros',
    history_file: 'Lista de vídeos de monitoramento histórico',
    select_time: 'Selecionar horário de início e fim',
    one_download: 'Download com um clique',
    new_psw_cycle: 'Novo período de senha',
    card_from: 'Origem do SIM',
    bind_date: 'Data de vinculação',
    activation_date: 'Data de ativação',
    open_card: 'Data de abertura do cartão',
    flow_expire: 'Data de expiração do tráfego',
    pay_date: 'Data do último pagamento',
    next_pay_date: 'Data do próximo pagamento',
    flow_total: 'Tráfego total do mês',
    flow_used: 'Tráfego utilizado',
    write: 'Escrever',
    read: 'Ler',
    program_version: 'Número da versão do programa',
    param_version: 'Número da versão dos parâmetros',
    configuration_file: 'Arquivo de configuração',
    main_board_param_config: 'Itens de configuração da placa mãe',
    statistics: 'Informações estatísticas',
    total_number: 'Número total de operações (vezes)',
    total_time: 'Tempo total de operação (h)',
    total_power: 'Consumo total de energia (KW·h)',
    total_opend: 'Número total de aberturas de porta (vezes)',
    floors_show: 'Exibição de andares',
    protocol_version: 'Número da versão do protocolo',
    file_name: 'Nome do arquivo',
    download_status: 'Status do download',
    file_size: 'Tamanho do arquivo',
    monitor_time: 'Hora do monitoramento',
    remove: 'Remover',
    is_delete: 'Tem certeza de que deseja excluir este registro?',
    file_is_download: 'Este arquivo está sendo baixado, não é possível executar esta operação',
    fault_id: 'ID da falha',
    fault_param: "Parâmetros na hora da falha",
    sequence: 'Número de sequência',
    param_name: 'Nome do parâmetro',
    param_value: 'Valor do parâmetro',
    remark107: 'Este elevador não está vinculado a um terminal ou está offline, não é possível executar a operação',
    remark108: 'Falha na conexão com o terminal!',
    remark109: 'O elevador atual está em estado de monitoramento e não pode executar esta operação!',
    remark110: 'Nenhum dado para download selecionado',
    remark111: 'Tem certeza de que deseja baixar os selecionados?',
    remark112: 'itens de dados',
    remark113: 'Operação proibida para elevadores virtuais',
    remark114: 'Por favor, insira sua senha de login',
    remark115: 'A指令 requer sua senha de login',
    remark116: 'Por favor, insira os parâmetros que precisam ser alterados',
    remark117: 'Por favor, selecione a指令 para executar',
    cancel_command: 'Cancelar a instrução',
    reset: 'Redefinir',
    restor_reset: 'Restaurar fábrica e redefinir',
    save_param: 'Salvar parâmetros',
    save_reset: 'Salvar parâmetros e redefinir',
    enter_level1: 'Acessar nível de segurança 1',
    enter_level2: 'Acessar nível de segurança 2',
    sended_command: 'A instrução foi enviada',
    remark118: 'A senha não pode estar vazia',
    remark119: 'Por favor, preencha o número de meses do ciclo de senha',
    remark120: 'Não é possível executar esta operação enquanto o download de arquivos históricos estiver em andamento',
    remark121: 'O conteúdo da pesquisa não pode estar vazio',
    remark122: 'Falha ao carregar dados',
    remark123: 'Tempo limite para obter parâmetros de operação do elevador!',
    remark124: 'Falha, por favor, tente novamente',
    remark125: 'As datas selecionadas não podem estar vazias!',
    remark126: 'Tempo limite para obtenção',
    remark127: 'Não foi possível conectar ao serviço',
    remark128: 'Download em andamento...',
    remark129: 'O elevador atual não está vinculado a um dispositivo terminal de reconhecimento facial',
    remark130: 'Tempo limite para conexão com o terminal',
    remark131: 'Falha na conexão com o terminal',
    remark132: 'Desconhecido',
    remark133: 'Tem certeza de que deseja reiniciar o App interno do dispositivo terminal atual?',
    remark134: 'Reinicialização bem-sucedida',
    remark135: 'Falha ao enviar a instrução, tente novamente',
    remark136: 'Tempo limite para retorno de dados da placa mãe',
    remark137: 'Lendo dados',
    remark138: 'Falha ao ler dados',
    unknown_fault: 'Falha desconhecida',
    door_lock_loop1: "Circuito de bloqueio de porta 1",
    scram_loop1: "Circuito de parada de emergência 1",
    door_area: "Área da porta",
    door_area1: "Área da porta 1",
    door_area2: "Área da porta 2",
    converter_fault: "Falha no conversor",
    KMC: "KMC",
    KDY: "KDY",
    opend_brake: "Abrir freio",
    inverter_run: "Conversor em operação",
    inverter_enable: "Conversor habilitado",
    KMC_output: "Saída KMC",
    KDY_output: "Saída KDY",
    door_area_up: "Área da porta superior",
    door_area_down: "Área da porta inferior",
    station_broadcast: "Sinal de anúncio de estação",
    run_down: "Descendo",
    run_up: "Subindo",
    running: "Em operação",
    running1: "Em operação 1",
    front_door: 'Porta frontal',
    back_door: 'Porta traseira',
    front_door_opened: "Porta frontal aberta completamente",
    front_door_opening: "Porta frontal abrindo",
    front_door_closed: "Porta frontal fechada completamente",
    front_door_closing: "Porta frontal fechando",
    front_light_curtains: "Cortina de luz frontal",
    front_touch_board: "Placa de toque frontal",
    back_door_opened: "Porta traseira aberta completamente",
    back_door_opening: "Porta traseira abrindo",
    back_door_closed: "Porta traseira fechada completamente",
    back_door_closing: "Porta traseira fechando",
    back_light_curtains: "Cortina de luz traseira",
    back_touch_board: "Placa de toque traseira",
    load_less: "Carga leve",
    load_more: "Carga pesada",
    load_full: "Carga cheia",
    load_over: "Sobrecarga",
    control_multiple: "Controle em grupo",
    control_double: "Controle em paralelo",
    endpoint_secondary_up: "Última estação superior",
    endpoint_secondary_down: "Próxima estação inferior",
    endpoint_up: "Estação superior",
    endpoint_down: "Estação inferior",
    limit_up: "Limite superior",
    limit_down: "Limite inferior",
    run_status: "Status de operação do elevador", //  1-automático, 2-manutenção, 3-motorista, 4-especial, 5-incêndio, 6-bloqueado, 7-VIP, 8-falha
    floor_current: "Andar atual", //(absoluto, o andar mais baixo é 1)
    running_interval: "Intervalo da curva de operação", // 0-parado, 1-aceleração, 2-velocidade constante, 3-frenagem, 4-rastejamento, 5-manter velocidade zero
    zero_speed: "Velocidade zero",
    change_speed_mark: "Mudança de velocidade",
    curve_change_speed: "Mudança de velocidade por curva",
    change_direction_openid: "Abrir porta na mudança de direção",
    running_speed: "Velocidade de operação", //(m/s)
    lift_status: 'Status do elevador',
    stop: 'Parado',
    safety_circuit: 'Circuito de segurança',
    closed: 'Fechado',
    break: 'Aberto',
    flat_signal: 'Sinal de nivelamento',
    effective: 'Eficaz',
    no_effective: 'Ineficaz',
    shaft_switch: 'Interruptor do poço',
    cage_load: 'Carga da cabina (pesagem)',
    digital_cage: "Leitura do módulo de pesagem digital da cabina --% (apresenta se o percentual não for zero)",
    front_signal: 'Sinal da porta frontal',
    back_signal: 'Sinal da porta traseira',
    door_opened: 'Porta aberta completamente',
    door_closed: 'Porta fechada completamente',
    safety_light_curtain: 'Cortina de luz de segurança',
    security_contact: 'Placa de contato de segurança',
    open_door_instruction: 'Instruções de abertura',
    close_door_instruction: 'Instruções de fechamento',
    select_signal_ab: "Sinal de seleção interna: (apresenta apenas números com sinal de resposta, andar absoluto)",
    remark139: "Se a opção 'Porta transversal' estiver selecionada, os andares totais n+1~2n são seleções internas da porta traseira",
    remark140: 'Se a opção "Porta transversal" estiver selecionada, chamadas para cima acima de 32 são chamadas para cima da porta traseira',
    remark141: 'Se a opção "Porta transversal" estiver selecionada, chamadas para baixo acima de 32 são chamadas para baixo da porta traseira',
    remark142: "Sinal de chamada para cima: (apresenta apenas números com sinal de resposta, andar absoluto)",
    remark143: "Sinal de chamada para baixo: (apresenta apenas números com sinal de resposta, andar absoluto)",
    smart_screen_title: "Interface de gerenciamento da tela inteligente da Nuvem do Elevador",
    end_time: 'Data de vencimento',
    plays: 'Número de reproduções',
    add_video: 'Adicionar vídeo',
    edit_subtitles: 'Editar legendas',
    select_sound: 'Selecionar som de anúncio de estação',
    direction_wind: 'Direção do vento',
    wind: 'Força do vento',
    temperature: 'Temperatura',
    level: 'nível',
    volume: 'Ajuste de volume',
    system_volume: 'Volume do sistema',
    media_volume: 'Volume do vídeo',
    station_volume: 'Volume do áudio',
    current_brightness: "Brilho atual",
    brightness_control: 'Ajuste de brilho',
    open_volume: 'Som de abertura de porta',
    close_volume: 'Som de fechamento de porta',
    floor_volume: "Som de anúncio de andar",
    scrolling_speed: 'Velocidade de rolagem das legendas',
    next: 'Próximo',
    sync_msg_fail: "Falha ao enviar mensagem de sincronização",
    no_update_file: 'Arquivo de configuração não modificado',
    no_set_parameters: 'Existem vídeos com parâmetros não configurados',
    remark144: 'O tempo de vencimento padrão do elevador não está configurado',
    remote_sync_data: "Sincronização de dados remota em andamento",
    remark145: "Por favor, selecione a data de vencimento das legendas rolando!",
    remark146: "A data de vencimento não pode estar vazia",
    remark147: "Formato de arquivo incorreto!",
    remark148: 'Antes de fazer o upload do arquivo de áudio, certifique-se de que o nome do arquivo corresponda a um andar existente, no seguinte formato. Nome do arquivo correspondente ao 1º andar: 1.mp3',
    remark149: "Apenas números inteiros positivos entre 1 e 5 podem ser inseridos",
    remark150: "A velocidade de rolagem das legendas deve ser um número inteiro entre 1 e 10",
    Mon: 'Segunda-feira',
    Tue: 'Terça-feira',
    Wed: 'Quarta-feira',
    Thu: 'Quinta-feira',
    Fri: 'Sexta-feira',
    Sat: 'Sábado',
    Sun: 'Domingo',
    remark151: 'Falha na atualização remota da versão',
    remark152: 'Atualização remota da versão bem-sucedida',
    error: 'Erro',
    in: 'em',
    occur: 'ocorreu',
    remark153: 'falha número',
    remark154: 'Por favor, preste atenção e trate',
    lift_fault: 'Falha do elevador',
    fault_time: 'Hora da falha',
    remark155: "O elevador atual está em estado de socorro e não pode ser monitorado ou ter arquivos baixados",
    remark156: "O elevador atual está em estado de monitoramento e não pode ter arquivos baixados",
    remark157: "O elevador atual está em estado de download de arquivos e não pode ser monitorado",
    remark158: 'Versão atual do dispositivo',
    remark159: 'A versão mais recente é',
    remark160: 'Tem certeza de que deseja atualizar para a mais recente?',
    remark161: 'Falha ao enviar mensagem de atualização da versão do terminal',
    remark162: 'Atualização remota do terminal em andamento...',
    remark163: 'Falha ao retornar parâmetros da placa mãe, por favor, tente novamente',
    remark164: 'Falha ao ler parâmetros, por favor, tente novamente',
    agree: 'Concordo',
    focus: 'Favoritar',
    remark165: 'Clique para cancelar o favorito',
    remark166: 'Modificação bem-sucedida',
    remark167: 'Limpeza bem-sucedida',
    remark168: 'Tem certeza de que deseja excluir esta empresa?',
    remark169: 'Tem certeza de que deseja excluir este departamento?',
    remark170: 'A empresa tem membros subordinados, exclusão não permitida',
    remark171: 'O departamento tem membros subordinados, exclusão não permitida',
    remark172: 'O número total de andares de elevadores com porta transversal não pode ser maior que 32',
    remark173: 'Favoritado com sucesso',
    remark174: 'Voltar para o site oficial da Nuvem do Elevador',
    remark175: 'Voltar para a página inicial da plataforma da empresa selecionada atual',
    remark176: 'Voltar para a página anterior',
    remark177: ' 404-Página não encontrada',
    remark178: '403-Sem permissão',
    remark179: '500-Erro no servidor',
    remark180: 'Não foi possível conectar ao servidor',
    remark181: 'Tente executar o diagnosticador de rede',
    remark182: 'Funcionalidade em desenvolvimento',
    remark183: 'Senha alterada, por favor, faça login novamente',
    remark184: 'Alterar informações de andares requer sincronização com o terminal do dispositivo de acesso ao elevador, por favor, selecione o método de sincronização',
    remark185: "Sincronizar com o dispositivo terminal atual",
    remark186: "Sincronizar com todos os dispositivos terminais sob o certificado",
    remark187: '指令 enviada com sucesso',
    remark188: 'Número da versão do programa atual não obtido',
    remark189: 'Número da versão dos parâmetros atual não obtido',
    remark190: 'Os parâmetros a serem escritos não podem estar vazios',
    remark191: '指令 enviada com sucesso',
    remark192: 'Nota: O tamanho de pixel do arquivo enviado deve ser 207*40!',
    remark193: "No máximo 2 pessoas responsáveis por alertas de falhas podem ser preenchidas!",
    remark194: "Não configurado",
    remark195: 'Nenhuma informação de cartão SIM encontrada',
    remark196: 'A câmera do dispositivo terminal atual não está ativada',
    remark197: 'Por favor, adicione a configuração específica',
    remark198: 'Seleção de permissões especiais do departamento atual',
    remark199: 'Por favor, selecione o método de sincronização',
    remark200: 'Por favor, selecione a data de vencimento do monitoramento do elevador',
    remark201: 'Preencha as informações da plataforma de configuração',
    remark202: 'O formato do ID do terminal WCR vinculado é incorreto',
    remark203: 'Nota: Este modelo é usado para a função de importação em lote. Todas as informações de elevadores registrados são informações genéricas configuradas abaixo',
    no_focus: 'Cancelar favorito',
    click_focus: 'Clique para favoritar',
    about_expire: 'Próximo de vencer',
    out_of_traffic: 'Tráfego',
    no_datas: 'Nenhum dado',
    no_datas_curve: "Nenhum dado ou arquivos de curva relacionados ausentes",
    private_role: "Função privada",
    directions: 'Instruções',
    dty_platform: 'Plataforma Nuvem do Elevador',
    operation_manual: "Manual de operação da plataforma",
    role_res_instructions: 'Instruções de gerenciamento de usuários e permissões',
    terminal_operation_manual: "Manual de operação do terminal de tela inteligente",
    face_operation_manual: "Manual de operação do terminal de reconhecimento facial",
    app_operation_manual: "Manual de operação do APP Nuvem do Elevador",
    Login_failure: "Falha no login",
    login_expired: 'Sua sessão de login expirou ou foi feita login em outro local. Por favor, faça login novamente garantindo a segurança da conta.',
    no_permission: "Sem permissão de acesso, por favor, contate o administrador da empresa",
    chooseCompany: 'Selecione a empresa para continuar',
    platform_res: 'Recursos da plataforma',
    app_res: "Recursos do APP",
    dtzj_res: "Recursos do Elevador Especialist",
    //终端列表
    terminal_list: 'Lista de terminais',
    terminal_manage: 'Gerenciamento de terminais',
    yd_bound: 'Vinculação de número de matrícula do elevador Yida ao terminal',
    terminal_identity: 'Identidade do terminal',
    terminal_account: 'Conta do terminal',
    terminal_pwd: 'Senha do terminal',
    yd_unique_code: 'único do Yida',
    yd_id_add: 'Registro do código único do elevador Yida',
    input: 'Registrar',
    no_connect: 'Não conectado à rede',
    wired_network: 'Fio',
    network: 'Conectado à rede',
    create_time: 'Hora de criação',
    delete_time: "Data de exclusão",
    click_copy_pwd: 'Clique para copiar a senha',
    update_time: 'Hora de atualização',
    print: 'Imprimir',
    qr_code: 'Código QR',
    terminal_info: 'Informações do terminal',
    copy_info: 'Copiado para a área de transferência',
    //故障列表
    fault_list: 'Lista de falhas',
    fault_month: 'Selecione o mês em que ocorreu a falha (últimos três anos)',
    untreated: 'Não tratada',
    processed: 'Tratada',
    fault_des: 'Descrição da falha',
    fault_code: 'Número da falha',
    fault_no: 'Código da falha',
    fault_explanation: 'Explicação da falha',
    resume: 'Recuperar',
    history_delete:'Histórico',
    resume_condition: 'Condição de recuperação',
    fault_solution: 'Solução para a falha',
    fault_state: 'Estado na hora da falha',
    device_info: 'Informações do elevador',
    install_location: 'Local de instalação',
    device_id: 'ID do elevador',
    terminal_number: 'Número do terminal',
    alerter: 'Pessoa alertada',
    lift_device: 'Número do dispositivo do elevador',
    fault_floor: 'Andar onde ocorreu a falha',
    occur_time: 'Hora de ocorrência',
    handle_time: 'Hora de tratamento',
    state_display: 'Exibição de estado',
    state_para: 'Parâmetros de estado',
    auto: 'Automático',
    //sim卡列表
    sim_list: 'Lista de cartões SIM',
    sim_manage: 'Gerenciamento de cartões SIM',
    sim_info: 'Informações do cartão SIM',
    pay: 'Pagar',
    order: 'Pedido',
    import: 'Importar',
    add_batch: 'Adicionar ao processamento em lote',
    operator: 'Operadora',
    from_card: 'Origem',
    china_mobile: 'China Mobile',
    card_state: 'Estado do cartão',
    net_type: 'Tipo de rede',
    card_open_time: 'Hora de abertura do cartão',
    card_end_time: 'Data de expiração do tráfego',
    effective_time: 'Hora de entrada em vigor',
    no_package_msg: 'Sem informações de pacote',
    ali_cloud: 'Aliyun',
    inactivated: 'Não ativado',
    arrears: 'Em débito',
    out_service: 'Desativado',
    account_cancel: 'Cancelamento de conta',
    will_expire: 'Próximo de expirar',
    package_will_out: 'O tráfego está a acabar',
    package_will_out2: 'O tráfego está quase esgotado e expira',
    order_created: 'Pedido criado',
    write_off_time: 'Hora de cancelamento',
    package_end_time: 'Data de expiração do pacote',
    detail: 'Detalhes',
    number: 'Quantidade',
    development: "Desenvolvimento",
    res_manage: 'Gerenciamento de recursos',
    server_exception: 'Exceção no servidor',
    terminal_exception: "Exceção no terminal",
    crash_log: 'Log de falhas',
    address_parsing_error:"Erro ao analisar o endereço",
    explain: 'Descrição',
    unknown_location:"Localização desconhecida",
    unset_elevator_address:"Campo de endereço do elevador não definido",
    4011: 'Usuário não existe',
    4012: 'Usuário não existe ou nome de usuário/senha incorretos',
    4013: 'A senha do usuário deve conter pelo menos um número, letras maiúsculas e minúsculas e caractere especial (!, @, #, $, %, ^, &, *)',
    4021: "Falha na exclusão, o usuário atual já foi excluído",
    4022: "Falha na exclusão",
    4023: "Falha na modificação",
    4024: "A senha inserida não corresponde à senha antiga, por favor, insira novamente",
    4025: "Falha ao alterar a senha, o usuário atual não existe",
    4026: "Número de telefone já existe",
    4027: "Nome de usuário já existe",
    4031: 'Nenhum elevador vinculado encontrado',
    4032: "Por favor, selecione o condomínio operacional",
    4033: "O proprietário atual já foi excluído ou não existe",
    4035: "Falha na autorização",
    4037: "Falha na renovação",
    4039: 'Falha na operação, por favor, verifique se a chave atual foi excluída',
    4041: "Este elevador já foi favoritado",
    4042: "Este elevador ainda não foi favoritado",
    4043: "O ID do terminal vinculado já foi vinculado a outro elevador",
    4045: "Falha na exclusão, o elevador atual já foi excluído",
    4044: 'Falha ao adicionar',
    4046: "Erro de parâmetro, falha no envio do comando",
    4047: "A senha do usuário atual está incorreta, o envio do comando falhou",
    4048: "Erro no arquivo",
    4049: "O andar só pode ser um número",
    4050: "Existem terminais já vinculados no arquivo",
    4061: "Terminal não existe",
    4062: "O número de matrícula único do elevador atual já existe",
    4071: 'Ocorreu um erro ao fazer a solicitação, certifique-se de que a solicitação foi feita por um meio legítimo',
    4072: 'Sua empresa não tem permissão de pagamento na conta da Nuvem do Elevador, por favor, verifique com o administrador do sistema antes de operar',
    4073: 'Saldo da conta da empresa insuficiente',
    4074: 'Você não é o especialista em operações de conta de pagamento da empresa atual, por favor, altere a conta designada para recarregamento ou verifique com o administrador do sistema antes de recarregar',
    4001: 'Erro nos parâmetros',
    4081: 'Número máximo de envios alcançado hoje, por favor, tente novamente amanhã',
    4082: 'Frequência excessiva, por favor, continue enviando após 60s',
    4084: 'Falha ao obter o código de verificação',
    4085: 'Usuário não existe ou o código de verificação expirou',
    4086: 'Código de verificação incorreto',
    4087: 'Código de verificação expirado',
    4088: 'Empresa operacional atual não selecionada',
    4090: 'O departamento ou empresa atual tem subordinados, não é possível excluir',
    4091: 'ID do terminal de reconhecimento facial já foi vinculado a outro elevador',
    4092: 'Nenhum dispositivo atual encontrado',
    4093: 'O usuário atual não existe na plataforma iecs, não é possível adicionar elevadores. Por favor, crie uma conta no iecs antes de executar esta operação!',
    4094: 'Falha ao adicionar! O número BS atual já está registrado',
    4095: 'IMSI e número BS não correspondem',
    4096: 'Número IMSI já existe',
    4097: 'A solicitação é muito frequente, por favor tente novamente mais tarde',
    4098: "Formato de número de telefone incorreto",
    4099: "Formato de e-mail incorreto",
    4100: "Frequência excessiva, por favor, continue enviando após 60 segundos",
    4101: "E-mail já existe",
    4102: "Erro nos parâmetros, por favor, insira o código de verificação correto",
    4103: "Erro nos parâmetros, código faltante",
    4104: "Nenhum registro correspondente ao código encontrado!",
    4105: "A conta e a chave são as mesmas da conta original e da chave original",
    4106: "Falha ao atualizar dados",
    4201: "Nome do elevador é obrigatório",
    4202: "O formato do conteúdo do campo do trabalhador de manutenção é incorreto",
    4203: "O conteúdo do campo de alerta para todos está formatado incorretamente",
    4204: "Existe um ICCID de cartão SIM vinculado no arquivo",
    4205: "iccid vinculado a outros IDs de terminal",
    4206: "O piso do elevador é obrigatório e os valores estão entre 1 e 64",
    4207: "O intervalo de valorização da comunidade é inteiro positivo, não é recomendado modificar esta opção",
    4208: "O valor da empresa de manutenção é inteiro positivo, não é recomendado modificar este item",
    4209: "O valor da porta é 0 ou 1, não é recomendado modificar esta opção",

    4210: "Valores de velocidade nominal são inteiros positivos ou decimais positivos",
    4211: "Valores nominais de carga são inteiros positivos ou decimais positivos",
    4212: "O comprimento máximo da string do código do fabricante é de 100",
    4213: "O comprimento máximo da corda do modelo de elevador é de 100",
    4214: "O comprimento máximo da cadeia ICCID é de 20",
    4215: "O comprimento máximo da string do ID do terminal é de 16",
    4216: "O comprimento máximo da string do código do dispositivo é de 100",
    4217: "O tamanho máximo da cadeia do elevador é 34.",
    4218: "Comprimento máximo de cadeia da marca é de 50",
    4219: "Entradas ICCID duplicadas",
    4220: "Número de trabalho único do elevador repetido",
    4221: "Entrada duplicada de ID de terminal",
    4222: "Existe um ID de terminal ilegal no arquivo, verifique",
    4223: "Número de trabalho único do elevador ilegal no arquivo, por favor, verifique",
    4224: "Existe um número de celular inválido, verifique!",
    4225: "Existem números de trabalho únicos duplicados no arquivo, verifique!",
    4226: "Importação do administrador Por favor, defina o campo de fábrica de elevador visível",
    4227:'Os números de telefone não podem ser repetidos dentro da mesma empresa',
    4228:'Os endereços de e-mail não podem ser duplicados dentro da mesma empresa',
    4229: 'A empresa não existe, por favor recarregue e tente novamente',
    5001:"Tempo limite de resposta do terminal",
    5002:'O dispositivo está offline',
    5003:'Serviço de monitoramento de dados expirado',
    5004:'O dispositivo não existe',
    5005:'O dispositivo atual foi restaurado, não funcione continuamente',
    5006:'O terminal atual não existe',
    5007:'O terminal atual está ligado e não pode ser recuperado',
    5008: 'Por favor preencha o nome de utilizador',
    5009: 'Selecione a empresa para realizar a operação',
    5010: 'O número de telefone já existe',
    "-1": 'Erro desconhecido',
    401: "Não logado",
    402: "Sua conta teve uma entrada anormal, por favor, faça login novamente",
    403: "Sessão expirada, por favor, faça login novamente",
    413: "A senha é muito simples, por favor reinicie a senha",
    414: "Informações da conta não correspondem, sem permissão para executar esta operação",
    push_param_error1: "Por favor, preencha o campo do número de série de fábrica do elevador",
    push_param_error2: "Por favor, preencha o campo do código de crédito social uniforme da unidade fabricante",
    push_param_error3: "Por favor, preencha o campo do código de registro do elevador",
    hint1: 'A conta não pode estar vazia',
    hint2: 'O número de telefone não pode estar vazio',
    hint3: 'O código de verificação não pode estar vazio',
    hint4: 'SMS enviado com sucesso, por favor, verifique',
    hint5: 'Nenhuma empresa disponível, por favor, crie uma empresa',
    type: 'Tipo',
    role: 'Função',
    bind_community: 'Vincular condomínio',
    contact: 'Contato',
    hint6: 'Solicitação de assinatura de SMS de push',
    hint7: 'Solicitação de assinatura de SMS de push, por exemplo: 【Shenyang Blue Light】',
    hint8: 'Vincular elevador manualmente',
    hint9: 'Habilitar permissões especiais',
    hint10: 'Permissões especiais',
    web_permission: 'Permissões da plataforma',
    app_permission: 'Permissões do App Nuvem do Elevador',
    DTZJ_permission: 'Permissões do App Elevador Especialist',
    name1: 'Nome',
    find_community: 'Pesquisar nome do condomínio',
    click_edit: 'Clique para editar',
    add_son: 'Adicionar subordinado',
    property: 'Propriedade',
    bind_test: 'Vinculação de elevador de demonstração',
    bind_device: 'Vincular elevador',
    create_company: 'Criar empresa',
    user_info: 'Informações do usuário',
    add_user: 'Adicionar novo usuário',
    role_permission: 'Funções e permissões',
    role_name: 'Nome da função',
    bind_permission: 'Vincular permissões',
    hint11: 'Sem permissão de operação',
    hint12: 'Você não tem permissão para executar esta operação',
    create_department: 'Criar empresa subordinada',
    hint13: 'Pressione Enter para adicionar e-mail',
    hint14: 'Por favor, insira o e-mail',
    hint15: 'Endereço de e-mail duplicado',
    subcompany: 'Filial',
    hint16: 'Deseja excluir o usuário?',
    hint17: 'Deseja habilitar o aviso de falha na página?',
    edit_name: 'Alterar nome',
    create_type: 'Modo de criação',
    single: 'Individual',
    batch: 'Em lote',
    batch_add_build: 'Criar elevadores em lote',
    batch_add_unit: 'Criar unidades em lote',
    build_pre: 'Prefixo do nome do edifício',
    build_suf: 'Sufixo do nome do edifício',
    hint18: 'Por favor, insira o número do edifício',
    hint19: 'Este número já foi adicionado',
    hint20: 'O número final não pode ser menor que o número inicial',
    hint21: 'Por favor, adicione um número de edifício personalizado',
    hint22: 'Por favor, preencha o nome',
    hint23: 'Por exemplo: A, Vila, Alto...',
    hint24: 'Por exemplo: #, #Edifício...',
    hint25: 'Pressione Enter para adicionar',
    hint26: 'Por exemplo: U, Unit, A...',
    hint27: 'Por exemplo: Unidade, Porta...',
    no_type: 'Tipo de número',
    number1: 'Número',
    letter: 'Letra',
    customize: 'Personalizado',
    start_no: 'Número inicial',
    end_no: 'Número final',
    build_no: 'Número do edifício',
    create_build_name: 'Gerar nome do edifício',
    unit_pre: 'Prefixo do nome da unidade',
    unit_suf: 'Sufixo do nome da unidade',
    create_unit_name: 'Gerar nome da unidade',
    pre: 'Prefixo',
    customize_pre: 'Prefixo personalizado',
    start_floor: 'Andar inicial',
    end_floor: 'Andar final',
    users_floor: 'Número de usuários por andar',
    delimiter: 'Delimitador',
    user_no_type: 'Tipo de número de família',
    create_user_name: 'Gerar nome do morador',
    batch_add: 'Criar em lote',
    set: 'Configurar',
    add_build: 'Adicionar edifício',
    build: 'Edifício',
    unit: 'Unidade',
    tenement: 'Morador',
    add_unit: 'Adicionar unidade',
    hint28: 'Permissão facial Abrir',
    hint29: 'Permissão facial Fechar',
    hint30: 'Permissão de acesso ao elevador via código QR habilitada',
    hint31: 'Permissão de acesso ao elevador via código QR desabilitada',
    hint32: 'Selecionar data de expiração',
    the_term: 'Prazo',
    times: 'Vezes',
    floor_name: 'Nome do andar',
    unstop: 'Este andar não para',
    month_number: 'Número de meses atuais',
    rename: 'Renomear',
    hint33: 'Não modificado',
    hint34: 'Confirmar exclusão',
    trap_persons: 'Estatísticas de pessoas presas',
    hint35: 'Está em vídeo, tem certeza de que deseja fechar?',
    my_msg: 'Minhas mensagens',
    no_msg: 'Nenhuma mensagem',
    refuse: 'Recusar',
    notify_msg: 'Mensagem de notificação',
    sign_application: 'Solicitação de aprovação de assinatura',
    hint36: 'Inicie o incidente de socorro, por favor, resolva o mais rápido possível',
    occur_location: 'Local de ocorrência',
    hint37: 'Clique para ir para a tela de monitoramento',
    exception: 'Anormalidade',
    para: 'Parâmetro',
    manager: 'Administrador',
    stack_track: 'Informações de pilha',
    redis_test: 'Teste Redis',
    redis_count: 'Estatísticas Redis',
    resource: 'Recurso',
    res_delete: 'Excluir recurso',
    res_edit: 'Alterar recurso',
    new_subsystem: 'Criar novo subnível',
    new_sibling: 'Criar novo nível igual',
    copy_suc: 'Cópia bem-sucedida',
    hint38: 'Copiado para a área de transferência',
    hint39: 'Tem certeza de que deseja excluir?',
    hint40: 'Funcionalidade ainda não implementada',
    hint41: "Elevadores virtuais não podem ser favoritados",
    hint42: 'Por favor, determine o tipo de elevador principal e secundário atual',
    hint43: 'O número total de andares de elevadores com porta transversal não pode ser maior que 32',
    hint44: 'O número total de andares do elevador secundário não pode ser maior que o do elevador principal',
    hint45: 'Situação de estatísticas anuais de dados',
    detail_content: 'Conteúdo detalhado',
    hint46: 'Carregando dados...',
    dty_explain1: 'Manual de operação da plataforma Nuvem do Elevador.pdf',
    dty_explain2: 'Instruções de gerenciamento de usuários e permissões da plataforma Nuvem do Elevador.pdf',
    smart_explain: 'Manual de operação da tela inteligente.pdf',
    face_explain1: '8 polegadas reconhecimento facial elevador integrado instruções.pdf',
    face_explain2: '10 polegadas reconhecimento facial elevador integrado instruções.pdf',
    dty_app_explain: 'Manual do App Nuvem do Elevador.pdf',
    hint47: 'Carregando componente...',
    page_title: 'Título da página',
    window: 'Janela',
    renewal: 'Renovação',
    hint48: 'Selecione a operação que deseja realizar',
    entrance_guard: 'Controle de acesso',
    hint49: 'Não é possível adicionar nomes duplicados',
    hint50: 'Nome não modificado',
    hint51: 'Nome já existe',
    binding: 'Vinculação',
    binding_suc: 'Vinculado',
    cancel_binding_suc: 'Desvinculação bem-sucedida',
    hint52: 'Habilitar função de recarregamento',
    account_balance: 'Saldo da conta',
    hint53: 'Atualizar lista de responsáveis',
    hint54: 'Preencha a assinatura de SMS e clique em "Confirmar" para enviar automaticamente a solicitação.',
    hint55: 'Após aprovação, as notificações de falha do elevador da fábrica serão enviadas com esta assinatura.',
    hint56: 'Assinatura de SMS autenticada',
    hint57: 'Assinatura de SMS não aprovada',
    hint58: 'Clique para editar novamente',
    hint59: 'Assinatura de SMS em processamento de aprovação',
    hint60: 'Preencha a assinatura de SMS e clique em "Confirmar" para enviar automaticamente a solicitação.',
    hint61: 'Após aprovação, as notificações de falha do elevador da fábrica serão enviadas com esta assinatura.',
    hint62: 'Empresa / Departamento a que pertence',
    depart_num: 'departamentos',
    hint63: 'Por favor, selecione o condomínio atual para operar',
    current_fault: 'Número de elevadores com falhas atuais',
    sim_over: 'Número de cartões SIM com vencimento próximo ou expirado',
    lift_trapped: 'Número de elevadores com pessoas presas',
    hint64: 'Monitoramento de vídeo de socorro',
    hint65: 'Botão SMS',
    up: 'Subindo',
    down: 'Descendo',
    queryMaintenance: "Ver manutenção",
    addMaintenance: "Adicionar manutenção",
    m_depart: "Unidade de manutenção",
    m_user: "Pessoa responsável pela manutenção",
    m_date: "Data da manutenção",
    m_type: "Tipo de manutenção",
    m_content: "Conteúdo da manutenção",
    m_remarker: "Comentário",
    down_face: "Baixar dados faciais",
    push_data: "Enviar dados para a plataforma",
    shijian: 'Tempo',
    device_curve_list: "Análise de curva do elevador",
    data_statistic: "Estatísticas de dados",
    terminal_id_curve: "Terminal de monitoramento de vibração e ruído",
    search: 'Pesquisar',
    device_history_curve: 'Análise de curva de operação histórica do elevador',
    add_remark: "Adicionar comentário",
    look_remark: 'Ver comentário',
    maintain_list: 'Lista de manutenção',
    health: "Nível de saúde",
    start_time: 'Hora de início',
    final_time: "Hora de término",
    last_m_weibao: 'Última data de manutenção',
    lift_monitor_end_time: 'Monitor validade Date',
    show_lift_endtime: "Tempo de validade",
    device_expire: 'Permissão de monitoramento do elevador expirada',
    change_community_role: 'Alterar identidade no condomínio',
    push_filed_setting: "Configuração de campos de push",
    describe: "Descrição",
    end_time_device_list: "Lista de elevadores com vencimento",
    remark204: "Por favor, selecione a data de expiração do elevador",
    batch_renew: 'Renovar em lote',
    remark205: "Por favor, selecione os elevadores para renovar",
    remark206: "Não é possível registrar o terminal WCR versão 2G. Para registrar, acesse o site oficial do IECS",
    city: 'Cidade',
    settings_desc: "Descrição da configuração",
    brand: 'Marca',
    auto_unicom: 'Unicom automatizado',
    other: 'Outro',
    all_factory: 'Todas as fábricas',
    IMSI: 'IMSI',
    floor_station_door: 'Andar*Estação*Porta',
    leave_factory_date: 'Data de saída da fábrica',
    throw_in_date: 'Data de inserção',
    next_year_date: 'Próxima data de inspeção anual',
    Delivery: 'Entregue ou não',
    CONTRACT: 'Número do contrato',
    INSTALLATION: 'Unidade de instalação',
    INSTALLATIONMAN: 'Pessoa instaladora',
    INSTALLATIONMANMOBILE: 'Telefone da pessoa instaladora',
    CONSUMER: 'Unidade de uso',
    USEOCCASION: 'Ocasião de uso',
    OWNER: 'Propriedade',
    PROPERTY: 'Unidade imobiliária',
    WYRY: 'Pessoa imobiliária',
    WYDH: 'Telefone da imobiliária',
    project_name: 'Nome do projeto',
    parts_life_settings: 'Configuração de tempo de uso de peças',
    parts_name: 'Nome da peça',
    life_limit: 'Limite de vida útil',
    life_limit_default: 'Valor padrão do modelo de limite de vida útil',
    warn_monitor: 'Alerta de vida útil de peças',
    parts_warn_config: 'Configuração de alerta de peças',
    device_qrcode: 'Código QR do dispositivo',
    use_time: 'Tempo de uso',
    warn_time: 'Tempo de alerta',
    warn_detail: 'Detalhes do alerta',
    running_time: 'Tempo de operação do elevador desde a上线 na plataforma',
    to_zero: 'Zerar',
    change_war_config: 'Alterar configuração de alerta',
    change_deviceInfo_config: 'Alterar configuração de informações do elevador',
    user_list: 'Usuário',
    user_table: 'Lista de usuários',
    authority: 'Permissão',
    visible_device: 'Elevador',
    assigned_to: 'Vincular',
    unassigned_to: 'Desvincular',
    remove_device: 'Desvincular empresa',
    BS: 'Número BS',
    remove_user: 'Pessoa que excluiu',
    remove_user_mobile: 'Telefone da pessoa que excluiu',
    band_unband_user: 'Vincular/desvincular usuário',
    band_company: 'Vincular empresa',
    unband_user: 'Desvincular usuário',
    band_user: 'Vincular usuário',
    equipment_code: 'Código do dispositivo',
    register_number: 'Código de registro do dispositivo',
    selectuserofdevice: "Seleção de elevadores da lista de consulta do usuário",
    none: 'Nenhum',
    export: 'Exportar',
    sync_all: 'Sincronizar tudo',
    synchronization_part: "Sincronizar parte",
    remote_controls: 'Habilitar ou não o controle remoto',
    open_close_door: 'Abrir/fechar porta',
    call_lift: 'Chamar',
    remote_open_door: 'Abrir porta remotamente',
    remote_close_door: 'Fechar porta remot',
    no_body: 'Ninguém',
    some_body: 'Alguém',
    behavior: 'Comportamento',
    qr_id: 'Identificação única do scanner de QR code',
    export_fault_record: 'Exportar registro de falhas',
    aed_list: "Lista de AED",
    aed_fault_list: "Lista de falhas de AED",
    device_name: "Nome do dispositivo",
    device_desc: 'Descrição do dispositivo',
    event_list: "Lista de eventos",
    event_code: "Código",
    gb_event_no: "Padrão nacional",
    event_no: "Código",
    event_name: "Nome do evento",
    event_explain: "Explicação do evento",
    gb_fault_no: "Código Internacional",
    company_info: "Informações da empresa",
    event_save: "Habilitar ou não o armazenamento de eventos",
    set_pwd: "Redefinir senha",
    pwd_again: "Confirmar senha",
    pwd_again_not_empty: 'A confirmação da senha não pode estar vazia',
    new_pwd_set: "Redefinição de nova senha",
    menu_dtzj: "Elevador Especialist",
    version_manage: "Manutenção de versões",
    data_manage: 'Manutenção de dados',
    logs_manage: 'Estatísticas de logs',
    setting_item: "Item de configuração",
    data_type: "Tipo de dados",
    extract_code: "Código de extração",
    help_seekers: "Pessoa solicitando ajuda",
    seeking_help: "Pessoa auxiliada",
    upload_time: "Hora do upload",
    download: "Download",
    message_content: "Conteúdo da mensagem",
    version_name: "Nome da versão",
    publisher: "Publicador",
    publisher_time: "Hora de publicação",
    publisher_new: "Publicar nova versão",
    bl6_active: "Ativação do bl6",
    holding_version: "Versão Elevador Especialista",
    mobile_model: "Modelo",
    mobile_sys: "Elevador Especialista",
    variety: 'Tipo de dispositivo',
    variety_type1: "Elevador de carga",
    variety_type2: "Elevador de carga de tração",
    variety_type3: "Elevador de carga forçado",
    variety_type4: "Elevador de carga sem quarto de máquinas",
    variety_type5: "Elevador para carros",
    variety_type6: "Elevador de carga explosion-proof",
    variety_type7: "Elevador hidráulico",
    variety_type8: "Elevador hidráulico para passageiros",
    variety_type9: "Elevador hidráulico para passageiros explosion-proof",
    variety_type10: "Elevador hidráulico de carga",
    variety_type11: "Elevador hidráulico de carga explosion-proof",
    variety_type12: "Elevador de objetos pequenos",
    variety_type13: "Escada rolante",
    variety_type14: "Passarela móvel",
    manufacturing: 'Nome da unidade fabricante',
    import_agent_name: 'Nome do agente importador',
    production_date: 'Data de fabricação',
    installation_name: 'Nome da unidade de instalação',
    installation_check_date: 'Data de supervisão da instalação',
    renovation_name: 'Nome da unidade de reforma',
    renovation_check_date: 'Data da Supervisão da Reforma',
    major_repairs_name: 'Nome da unidade de Reparação',
    major_repairs_check_date: 'Data reparos importantes',
    doors: 'Número de portas',
    up_rated_speed: 'Velocidade nominal de subida',
    down_rated_speed: 'Velocidade nominal de descida',
    mt_type1:'Resgate de pessoas presas',
    mt_type2:'Tratamento de alarmes',
    mt_type3:'Manutenção',
    mt_type4:'Reparo',
    mt_type5:'Detecção',
    mt_type6:'Outro',
    opinion:'Comentário da unidade de uso',
    whole_machine_code:"Código do conjunto",
    mt_details:"Detalhes da manutenção",
    receive_time:"Hora de envio de serviço",
    maintain_num:'Número do seguro',
    insurance_expire:"Data de expiração do seguro",
    insurance_number:'Número do seguro',
    insurance_unit:'Unidade seguradora',
    internal_code:'Código interno de uso',
    mt_company_hotline:'Linha de manutenção',
    restore_time:"Hora de restauração",
    special_mode:'Especial',
    switch_open:'Abra.',
    switch_close:'Fechar',
    pusher_config:"Empurrar",
    add_account:'Adicionar subconta',
    wuhan_pusher_config:'Geração de conta de push de Wuhan',
    child_account:'Informações da subconta',
    batch_set_config:"Quantidade Configuração",
    access:"Acesso",
    cancel_access:"Cancelar acesso",
    push_scheme:"Plano de push",
    doc_explain:"Explicação do documento",
    doc_upload:"Upload de documento explicativo",
    pusher_name:"Nome configuração",
    active_code:'Código de ativação',
    operate_user:'Operador',
    pusher_describe:'Explicação das informações da conta da plataforma',
    pusher_account:'Lista de contas de push',
    account:'Conta',
    secretKey:'Chave secreta',
    pusher_code:'Código único do plano de push',
    relationship_structure:"Estrutura de relacionamento com o usuário",
    lift_monitor_config:'Monitoramento do tempo de validade',
    warn_note:'Note',
    advanced_permission:'Avançadas',
    all:'Todos',
    voice:'Voice',
    picture:'Fotos',
    feedback:'Comentários',
    oscilloscope_curve:'Oscillómetro',
    text:'Texto',
    recorder_data:'Gravador',
    return_parameters:'Retorno Parâmetros',
    fault_analysis:'Falha Análise',
    maintenance_fault:'Reparação de falhas',
    no_maintenance_fault:'Falha não de reparação',
    APK_type:'APK Type',
    btn_push_test:'Teste de Comunicação',
    delete_bind_terminal:'Terminal de ligação',
    btn_resume_device:'Recuperar básicas',
    delete_device_record:'Apagar o registro do dispositivo',
    resume_bind_terminal:'Restaurar a ligação de terminal',
    copy:'Copiar',



    remark207: "Ir para o site oficial do IECS",
    remark208: "O nome de usuário só pode consistir em números e letras",
    remark209: 'Deseja selecionar?',
    remark210: 'Fábricas de elevadores visíveis sem configuração de elevadores',
    remark211: 'Você ainda não configurou o alerta de peças, por favor, vá para',
    remark212: 'para configurar',
    remark213: 'Zerar o tempo de uso da peça',
    remark214: 'Já houve alerta?',
    remark215: 'Após zerar, o tempo de uso desta peça será recalculado a partir de 0. Certifique-se de ter realmente substituído a peça antes de executar esta operação.',
    remark216: 'Por favor, selecione o elevador para vincular',
    remark217: 'Por favor, selecione a empresa específica à esquerda para atribuir o elevador!',
    remark218: 'Tem certeza de que deseja vincular os elevadores selecionados à empresa atual?',
    remark219: 'Por favor, selecione a empresa ou usuário para atribuição',
    remark220: 'O elevador atual já existe na empresa selecionada, não é possível atribuí-lo novamente',
    remark221: 'Por favor, selecione os elevadores para desvincular',
    remark222: 'Tem certeza de que deseja desvincular esses elevadores da empresa selecionada?',
    remark223: 'Por favor, selecione a empresa da qual deseja desvincular os elevadores',
    remark224: 'Por favor, selecione a empresa para desvinculação',
    remark225: 'Tem certeza de que deseja desvincular esses elevadores?',
    remark226: 'O usuário logado atual não pode excluir sua própria conta',
    remark227: 'Tem certeza de que deseja recuperar o dispositivo já excluído?',
    remark228: 'Por favor, selecione o usuário para vincular (pesquisa disponível)',
    remark229: 'Nenhum usuário selecionado para vinculação',
    remark230: 'O dispositivo atual não está vinculado a nenhum usuário',
    remark231: 'Não vinculado a outros usuários',
    remark232: 'Tem certeza de que deseja exportar os dados? Observação: a exportação completa pode levar tempo, por favor, aguarde pacientemente.',
    remark233: "Por favor, salve o arquivo no formato Microsoft Excel 97-2003",
    remark234: "Por favor, insira o nome do dispositivo",
    remark235: "Por favor, insira a descrição do dispositivo",
    remark236: "Por favor, insira o modelo do dispositivo",
    remark237: "Por favor, insira a marca do dispositivo",
    remark238: "O nome do dispositivo não pode estar vazio",
    remark239: "Clique no botão para obter o código de verificação e complete o módulo de verificação abaixo para obtê-lo",
    remark240: "O Elevator Cloud lembra você para vincular seu número de telefone ou e-mail e aumentar a complexidade da senha para continuar a operação.",
    remark241: "O comprimento da senha diária do código QR é de 6 a 30 caracteres, deve conter números, letras maiúsculas e minúsculas, caracteres especiais (!, @, #, $, %, ^, &, *, _), não permite espaços e caracteres chineses.",
    remark242: "Por favor, preencha o fluxo de vídeo com o endereço no formato m3u8 correto",
    remark243: "Por favor, selecione o registro para excluir!",
    remark244: "O número da versão deve ser maior que 0!",
    remark245: "O tamanho do arquivo deve ser maior que 0!",
    remark246: "O usuário deve preencher ou o número de telefone ou o e-mail",
    remark247:'Os materiais de integração da plataforma são atualizados continuamente conforme as funções de integração mudam. A versão mais recente está disponível aqui',
    remark248:'Por favor, insira informações-chave como nome do elevador, número do terminal, modelo, localização, número do elevador, etc.',
    remark249:'Por favor, selecione os dispositivos para acesso ou cancelamento de acesso',
    remark250:'Por favor, selecione o plano de acesso',
    remark251:'Por favor, insira o nome da plataforma de push',
    remark252:'Querer consultar contas que não sejam nulas',
    remark253:"Escolha o tipo de APK",


    explain1: 'As permissões do tipo empresa são independentes, enquanto o tipo departamento possui todas as permissões da empresa pai.',
    explain2: 'Esta opção é visível para administradores. Ao criar uma nova empresa raiz, é possível selecionar funções padrão do sistema, correspondendo às permissões à direita, e a atribuição de permissões específicas também pode ser personalizada.',
    explain3: 'Após selecionar esta opção, todos os elevadores da empresa atual só poderão visualizar os elevadores vinculados por meio da função "Vincular elevador".',
    explain4: 'Se as permissões da função atual não forem suficientes, você pode marcar esta opção para adicionar outras permissões extras.',
    explain5: 'As permissões da plataforma referem-se à Nuvem do Elevador, e as permissões do APP referem-se ao App Nuvem do Elevador. Marque os nomes de permissões correspondentes para adicioná-las à função atual.',
    explain6: 'Se o novo usuário receber permissão para configurar a data de expiração do elevador',
    explain7: 'Ao atribuir chaves de código QR aos proprietários, o número máximo de atualizações da chave no dia. Se excedido, a chave de código QR não poderá ser obtida no dia.',
    explain8: 'A data de expiração padrão do elevador é de 12 meses. Após expirar, o status do elevador será exibido como offline, e o administrador pode alterar a data de expiração do elevador',
    explain9: 'Definir o usuário atual como administrador do condomínio atual. O administrador do condomínio pode exportar dados de usuários por meio do miniaplicativo "Nuvem do Elevador - Acesso" conectado ao terminal',
    explain10: 'Editar informações de exibição do andar. As informações específicas de exibição do andar são determinadas pelo número total de andares adicionados, onde o número total de andares = andares positivos + andares negativos',
    explain11: 'Marca do elevador',
    explain12: 'A empresa selecionada pode visualizar este elevador',
    explain13: 'A empresa selecionada e suas filiais podem visualizar este elevador',
    explain14: 'A modificação em lote só suporta a modificação de informações iguais em vários elevadores simultaneamente',
    explain15: 'Registrar informações do terminal por meio do número de matrícula único do elevador e do ID do terminal WCR',
    explain16: 'Nota: Este campo pode ser usado como campo de configuração de push em algumas plataformas de push. Este campo e o código de registro na Configuração de empurramento podem ser preenchidos alternadamente.',
    explain17: 'Após habilitar a opção de porta manual, a função de dados expandidos nos detalhes do elevador não poderá obter informações sobre o número de aberturas e fechamentos de portas durante a operação',
    explain18:"A partir de 23 de junho de 2025, o número máximo de pessoas alertadas para falhas é de duas. As configurações existentes antes desta data permanecerão inalteradas!",
    explain19:"Regras de envio de SMS de alerta de falha: o mesmo defeito em um dispositivo é enviado apenas uma vez por dia, e o número máximo de SMS de alerta de falha por dispositivo por dia é de três.Falhas sem limite de envio",
    explain20:"Os SMS de alerta de falha podem ser cancelados. Após o cancelamento, não será possível receber mais SMS de alerta de falha",
    explain21:"A função de SMS está habilitada por padrão no país. Se desabilitada, a interface do serviço de SMS da Aliyun não será usada. Em combinação com o limite de SMS, é possível definir o limite de envio de alertas por SMS por elevador.",
    explain22:"O limite de SMS é o limite de vezes de alertas por SMS por elevador. Em combinação com a função de SMS, se a função de SMS estiver habilitada e um valor limite for definido, nenhum alerta por SMS será enviado após atingir esse valor.",
    explain23:"Os fornecedores de serviços de mensagens de texto com o mesmo número estão limitados a enviar um máximo de 50 mensagens por minuto, um máximo de 50 mensagens por hora e um máximo de 50 mensagens por dia natural.",
    explain24:"Para códigos de falha especiais: 2 (fechamento da porta durante a operação do elevador), 37 (agitação do contador durante a operação da abertura da fechamento) Enviar uma vez após o elevador ocorrer três vezes por dia e, em seguida, não enviar mais.A falha 31 nunca envia mensagens de texto. A falha número 26 é enviada uma vez por dia.",
    explain25:'Nota: a partir de 19 de Janeiro de 2026, para registar uma conta nacional, introduza o número de telemóvel, para uma conta estrangeira, introduza o e-mail',

}